<template>
    <div>
      <router-view />
    </div>
  </template>
  <script>
  
  export default {
    name: "BlujayChainAccess",
    data () {
      return {}
    },
    created () {
  
    },
    methods: {
    
    },
  }
  
  </script>
  